module.exports = __webpack_public_path__ + "img/banner22@2x.d2295568.png";